export const MESSAGE_TIME = 4;
